export const urlify = (text) => {
    let urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function(url) {
      return '<a class="link" target="_blank" href="' + url + '">' + url + '</a>';
    })
  }